<template>
  <div v-if="!mobileCheck()" class="Header">
    <div class="Container">
      <a class="Header-left"  href="/">
        <img class="Header-logo" src="../../assets/vsys_supernodes.png" style="width: 260px;height: 70px;"/>
      </a>

      <div class="Header-link-container">
        <a href="/" class="Header-link" :class="{active: this.$route.path==='/'}">
          Home
        </a>

        <a href="/calculator" :class="{active: this.$route.path==='/calculator'}" target="_blank" class="Header-link">
          Calculator
        </a>

        <a href="https://v.systems/wallet.html" target="_blank" class="Header-link">
          Wallet
        </a>

        <a href="https://v.systems/vsys-coin" target="_blank" class="Header-link">
          Buy VSYS
        </a>

        <a href="https://goo.gl/forms/CVFsD4RpcaGreZtE2"  target="_blank" class="Header-link">
          List Node
        </a>

        <a href="https://v.systems/" target="_blank" class="Header-link">
          <img src="../../assets/vysy_coin.png" alt="" :style="{width: '15px'}">
       </a>
      </div>
    </div>
  </div>
  <div v-else class="mheaderCon">
    <div v-show="!menuShow" class="mheader mheader-top">
      <a v-show="!detailPage" class="mheader-logo" :class="{logoHide: searchShow}" href="/">
        <img src="../../assets/vsys_supernodes.png"  style="width: 1.5rem;height: 0.4rem;" />
      </a>
      <p @click="$router.go(-1)" v-show="detailPage && !menuShow && !searchShow" class="mheader-back">  Details</p>

     <el-input placeholder="Search by node name or address"
              v-model="input"
              @input="searchData"
              class="hinput"
              :class="{inputShow: searchShow}"
      ></el-input>

      <img v-show="!menuShow"  @click="handleSearchBtn" src="../../assets/ic_search_line.svg"/>
      <img @click="menuShow = !menuShow" v-show="!searchShow" :src="menuShow ? require('../../assets/ic_close.svg'):require('../../assets/ic_menu.svg')"/>
    </div>

    <div class="mheader" :class="{headerf: menuShow}">
      <div class="mheader-top blackbg" >
        <a  class="mheader-logo" href="/">
          <img src="../../assets/logo_white.svg" />
        </a>
        <img @click="menuShow = !menuShow" src="../../assets/ic_close.svg"/>
      </div>

      <div class="mheader-menu mshow" >
        <ul class="mheader-menuUl">
          <li><a href="" :class="{active: this.$route.path==='/'}">Home</a></li>

          <li><a href="https://v.systems/wallet.html" target="_blank" >Wallet</a></li>

          <li>><a href="https://v.systems/vsys-coin" target="_blank" >
            Buy VSYS</a></li>

          <li><a href="https://goo.gl/forms/CVFsD4RpcaGreZtE2"  target="_blank" >
          List Node</a></li>

          <li><a href="https://v.systems/">v.systems</a></li>
        </ul>
      </div>
    </div>
    <div class="fixedwrap"></div>

    <div class="history" v-show="searchShow" @click.self="searchShow = !searchShow">
      <div v-show="!searchDataShow && historyData.length>0" class="history-content" >
        <p class="history-p1" style="margin-bottom: 0.16rem">History</p>

        <div v-for="(item , idx) in historyData" class="history-item" :key="idx + Math.random()">
          <div @click="historyRoute(item)" >
            <div class="history-item-left">
              <img :src="item.logo">
              <span>{{item.name}}</span>
            </div>
          </div>
          <img @click="deleteHistory(item.address)" src="../../assets/ic_close_small.svg">
        </div>
      </div>

      <div v-if="nodeList.length>0" v-show="searchDataShow">
        <div class="nodeItem" v-for="(item , idx) in nodeList" @click="historyDataChange(item)"  :key="idx + Math.random()">
          <NodeItem :nodeData="item"/>
        </div>
      </div>
      <div v-else>
        <p class="history-p1" style="text-align: center;">-- No Result --</p>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { mobileCheck } from '@/utils/common';
  import NodeItem from '@/components/commons/NodeItem';

  export default {
    name: 'Header',
    components: {
      NodeItem,
    },

    data() {
      return {
        menuShow: false,
        searchShow: false,
        detailPage: this.$route.path.includes('detail'),
        input: '',
        searchDataShow: false,
        historyData: [],
        path: '',
      };
    },
    computed: {
      ...mapState('nodes', {
        nodeList: 'nodeList',
        allList: 'allList',
      }),
      // historyData: function(){
      //   return JSON.parse(sessionStorage.getItem("history")) || [];
      // }
    },
    watch: {
      input() {
        if (this.input) {
          this.searchDataShow = true;
        } else {
          this.searchDataShow = false;
          this.historyData = JSON.parse(sessionStorage.getItem('history')).slice(0, 3) || [];
        }
      },
      path() {
        this.menuShow = false;
        this.searchShow = false;
        this.searchDataShow = false;
      },
    },
    methods: {
      mobileCheck() {
        return mobileCheck();
      },
      searchData() {
        const allData = this.allList;
        const payload = {};
        if (!this.input) {
          payload.nodeList = allData;
        } else {
          const searchList = [];
          const len = allData.length;
          for (let i = 0; i < len; i += 1) {
            const item = allData[i];
            if (item.name.toUpperCase().indexOf(this.input.toUpperCase()) > -1
              || item.address.toUpperCase().indexOf(this.input.toUpperCase()) > -1) {
              searchList.push(item);
            }
          }
          payload.nodeList = searchList;
        }
        this.$store.commit('nodes/saveSearch', payload);
      },

      toTop() {
        window.scrollTo(0, 0);
      },

      handleSearchBtn() {
        if (!this.searchShow) {
          this.toTop();
        }
        this.searchShow = !this.searchShow;
      },

      storeHistory(node) {
        let history = JSON.parse(sessionStorage.getItem('history')) || [];
        history = history.filter(item => item.address != node.address);
        history.unshift(node);
        if (history.length > 10) {
          history.pop();
        }
        sessionStorage.setItem('history', JSON.stringify(history));
      },

      historyDataChange(node) {
        this.storeHistory(node);
        this.historyData = JSON.parse(sessionStorage.getItem('history')).slice(0, 3) || [];
      },

      historyRoute(item) {
        this.storeHistory(item);
        this.$router.push(`/detail/${item.address}`);
        this.historyData = JSON.parse(sessionStorage.getItem('history')).slice(0, 3) || [];
      },

      deleteHistory(address) {
        let history = JSON.parse(sessionStorage.getItem('history')) || [];
        history = history.filter(item => item.address != address);
        sessionStorage.setItem('history', JSON.stringify(history));
        this.historyData = JSON.parse(sessionStorage.getItem('history')).slice(0, 3) || [];
      },
      // historyData(){
      //   return JSON.parse(sessionStorage.getItem("history")) || [];
      // }
    },

    updated() {
      this.detailPage = this.$route.path.includes('detail');
      this.path = this.$route.path;
    },
    mounted() {
      if (sessionStorage.getItem('history') && JSON.parse(sessionStorage.getItem('history')).length > 0) {
        this.historyData = JSON.parse(sessionStorage.getItem('history')).slice(0, 3);
      }
    },

  };
</script>

<style lang="scss">
  .Header {
    .Container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 90px;
  }
    &-logo {
      height: 32px;
      margin-right: 10px;
    }
    &-left {
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: inherit;
    }
    &-link {
      color: #323233;
      font-size: 17px;
      margin-left: 40px;
      cursor: pointer;
    }
    &-link-container{
      display: flex;
    }
  }
  .active {
    color: #FF8837 !important;
  }

  .fixedwrap{
    height: 0.6rem;
    transition: background 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .fixedwraph0{
    height: 0;
  }
  .headerf{
    height: 5.67rem !important;
  }
  .blackbg{
    background: #161617;
  }
  .mheaderCon{
    max-width: 3.75rem;
    margin: 0 auto;
  }
  .positionNormal{
    position: initial !important;
  }
  .mheader{
    max-width: 3.75rem;
    height: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 3.75rem;
    z-index: 4;
    background: white;
    box-shadow: 0 2px 0.16rem rgba(#323233,0.08);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    &-top{
      height: 0.6rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 0.15rem;
      padding-right: 0.15rem;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      box-sizing: border-box;
    }
    &-logo{
      width: 2.36rem;
      height: 0.24rem;
      display: flex;
      transition: width 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      img{
        width: 100%;
        height: 100%;
      }
    }
    .logoHide{
      width: 0;
    }
    &-back{
      font-size: 0.16rem;
      color: #FF8837;
      width: 2.36rem;
      &::before{
        content: '';
        background: url('../../assets/ic_back_line.svg');
        background-size: cover;
        background-repeat: no-repeat;
        width: 0.09rem;
        height: 0.16rem;
        display: inline-block;
        position: relative;
        right: 0.03rem;
        top: 0.03rem;
      }
    }

    &-menuUl{
      margin: 0 auto;
      padding: 0;
      text-align: center;
      margin-top: 1rem;
      li{
        font-size: 0.18rem;
        margin-bottom: 0.4rem;
        a{
          color: white;
        }
      }
    }
    &-menu{
      height: 0;
      overflow: hidden;
      transition: height 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      background: #161617;
      margin-top: -1px;
    }
    .mshow{
      height: 5.07rem;
    }
    .hinput{
      width: 0;
      // margin-left: -0.2rem;
      transition: width 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      input{
        border: none !important;
        padding: 0;
      }
    }
    .inputShow{
      width: 3rem;
    }

  }
  .history{
    background: #F7F7FA;
    padding: 0.2rem 0.15rem 0.4rem 0.15rem;
    box-sizing: border-box;
    position: absolute;
    z-index: 3;
    width: 100%;
    max-width: 3.75rem;
    top: 0.6rem;
    box-shadow: 0 1px 0.1rem rgba(255, 136, 55, 0.8);
    &-content{
      padding: 0.15rem;
      background: white;
      border-radius: 0.06rem;
    }
    &-p1{
      font-size: 15px;
      color:#7D7D80;
    }
    &-item{
      display: flex;
      height: 0.6rem;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid #F5F5F7;
      &-left{
        display: flex;
        align-items: center;
        img{
          width: 0.28rem;
          margin-right: 0.1rem;
        }
        span{
          font-size: 0.16rem;
          color: #323233;
        }
      }
    }
    .nodeItem + .nodeItem{
      margin-top: 0.15rem;
    }
  }

</style>
